import type { ID, WithId } from '@octopus-do/octopus-project-core'

export const updateById = <T extends WithId>(
  id: ID,
  data: Partial<T>,
  array: T[]
): T[] =>
  array.map((item) => {
    if (item.id !== id) {
      return item
    }
    return { ...item, ...data }
  })
